(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

  const initHero = () => {
    if (!mq.matches) return;
    const hero = document.querySelector('[data-z7m-hero]');
    if (!hero || hero.dataset.z7mReady) return;
    hero.dataset.z7mReady = 'true';
    let ticking = false;
    const update = () => {
      ticking = false;
      const rect = hero.getBoundingClientRect();
      const h = Math.max(hero.offsetHeight, 1);
      const p = clamp((-rect.top) / (h * .72), 0, 1);
      hero.style.setProperty('--z7m-progress', p.toFixed(3));
    };
    const request = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
  };

  const initStickyBuy = () => {
    if (!mq.matches) return;
    const bar = document.querySelector('[data-z7m-sticky-buy]');
    const mainButton = document.querySelector('main[data-template="product"] .product-form__submit');
    if (!bar || !mainButton || bar.dataset.z7mReady) return;
    bar.dataset.z7mReady = 'true';
    const stickyButton = bar.querySelector('[data-z7m-sticky-button]');
    const stickyPrice = bar.querySelector('[data-z7m-sticky-price]');
    const priceRoot = document.querySelector('main[data-template="product"] [id^="price-"]');

    const sync = () => {
      const liveButton = document.querySelector('main[data-template="product"] .product-form__submit');
      if (liveButton && stickyButton) {
        stickyButton.disabled = !!liveButton.disabled || liveButton.getAttribute('aria-disabled') === 'true';
        stickyButton.textContent = stickyButton.disabled ? (liveButton.textContent.trim() || 'UNAVAILABLE') : 'ADD TO CART';
      }
      if (stickyPrice && priceRoot) {
        const sale = priceRoot.querySelector('.price-item--sale');
        const regular = priceRoot.querySelector('.price-item--regular');
        const source = sale && getComputedStyle(sale).display !== 'none' ? sale : regular;
        if (source && source.textContent.trim()) stickyPrice.textContent = source.textContent.trim();
      }
    };

    stickyButton?.addEventListener('click', () => {
      const liveButton = document.querySelector('main[data-template="product"] .product-form__submit');
      if (liveButton && !liveButton.disabled) liveButton.click();
    });

    const toggle = (visible) => {
      bar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('z7m-sticky-buy-active', visible);
    };
    const observer = new IntersectionObserver(([entry]) => {
      toggle(!entry.isIntersecting && window.scrollY > 280);
      sync();
    }, { threshold: .1 });
    observer.observe(mainButton);
    if (priceRoot) new MutationObserver(sync).observe(priceRoot, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', sync);
    sync();
  };

  const init = () => { initHero(); initStickyBuy(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
